import { AudioManager } from "../AudioManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameState } from "./GameState";

export class GameOverLayer extends Phaser.Group {

    private gameOverLabel: Phaser.Image;
    private tryAgainLabel: Phaser.BitmapText;
    
    constructor(game: Phaser.Game) {

        super(game, null, "game-over-layer");

        const backgroundSprite = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData("lila-square"));
        backgroundSprite.scale.setTo(GameConstants.GAME_WIDTH / 16, GameVars.gameHeight / 16);
        backgroundSprite.alpha = 0;
        this.add(backgroundSprite);
        
        this.game.add.tween(backgroundSprite)
            .to({alpha: .8}, 450, Phaser.Easing.Cubic.Out, true);

        let looksLikeStr: string;
        let tryAgainStr: string;

        if (GameVars.language === GameConstants.LANGUAGE_FRENCH) {
            looksLikeStr = "ça ressemble à";
            tryAgainStr = "mais tu peux réessayer";
        } else {
            looksLikeStr = "it looks like it's";
            tryAgainStr = "but we can try again";
        }
            
        const looksLike = new Phaser.BitmapText(this.game, GameConstants.GAME_WIDTH / 2, 220, "marker-felt", looksLikeStr, 40);
        looksLike.scale.x = GameVars.scaleX;
        looksLike.x -= looksLike.width / 2;
        looksLike.alpha = 0;
        this.add(looksLike);
        
        this.gameOverLabel = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 345, "texture_atlas_3", "txt_gameover.png");
        this.gameOverLabel.anchor.setTo(.5, .5);
        this.gameOverLabel.scale.x = GameVars.scaleX;
        this.gameOverLabel.alpha = 0;
        this.add(this.gameOverLabel);
        
        this.tryAgainLabel = new Phaser.BitmapText(this.game, GameConstants.GAME_WIDTH / 2, 430, "marker-felt", tryAgainStr, 40);
        this.tryAgainLabel.scale.x = GameVars.scaleX;
        this.tryAgainLabel.x -= this.tryAgainLabel.width / 2;
        this.tryAgainLabel.alpha = 0;
        this.add(this.tryAgainLabel);
                
        this.game.add.tween(looksLike)
            .to({alpha: 1}, 450, Phaser.Easing.Cubic.Out, true, 850)
            .onComplete.add(function(): void {
                    this.game.add.tween(this.gameOverLabel)
                    .to({alpha: 1}, 450, Phaser.Easing.Cubic.Out, true, 450)
                    .onComplete.add(function(): void {
                
                        this.game.add.tween(this.tryAgainLabel)
                            .to({alpha: 1 }, 450 , Phaser.Easing.Cubic.Out, true, 450)
                            .onComplete.add(function(): void {
                        
                        this.gameOver();
                    }, this);
                }, this);
            }, this);
    }
    
    private gameOver(): void {
        
        if (!AudioManager.getInstance().isAudioMuted) {
            AudioManager.getInstance().mute();
        }
        var that = this;
        PokiSDK.gameplayStop();
        PokiSDK.commercialBreak().then(
            () => {
                console.log("Commercial break finished, proceeding to game");
                PokiSDK.gameplayStart();

                if (!AudioManager.getInstance().isAudioMuted) {
                    AudioManager.getInstance().unmute();
                }
                that.game.time.events.add(3600, function(): void {
                    GameState.currentInstance.replay();
                }, that);
            }
        );
    }
}
